const Food = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer3"
      d="M28.144 36.946L8.262 56.829a2.441 2.441 0 0 0 0 3.456 2.443 2.443 0 0 0 3.456 0L31.6 40.4"
      fill={color}
    ></path>
    <path
      data-name="layer2"
      d="M28.144 36.946l30.25-30.251A12.238 12.238 0 0 1 58.374 24L41.118 41.258a6.118 6.118 0 0 1-8.652.011z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M41.118 41.258a6.1 6.1 0 0 1-2.711 1.574l17.155 17.156a2.444 2.444 0 0 0 3.456-3.458L42.432 39.943z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M42.532 42.672l1.314-1.315-1.414-1.414-1.314 1.314a6.1 6.1 0 0 1-2.711 1.574l1.414 1.414a6.092 6.092 0 0 0 2.711-1.573z"
      fill="#21205e"
      opacity=".15"
    ></path>
    <path
      data-name="opacity"
      fill="#fff"
      opacity=".3"
      d="M49.629 32.747H32.344l6.112-6.113h17.287l-6.114 6.113zm5.271-22.56h5.919a12.246 12.246 0 0 1-1.088 12.182h-17.01z"
    ></path>
    <path
      data-name="layer1"
      d="M12.4 3L10 5.4l12.917 12.906a1 1 0 0 1-1.417 1.415L8.591 6.809 5.841 9.56l12.912 12.912a1 1 0 1 1-1.414 1.414L4.427 10.973l-2.4 2.4 15.357 17.08c2.74 2.74 6.348 2.7 9.383.74l3.565 3.565L33.79 31.3l-3.566-3.566c1.965-3.032 2.052-6.589-.689-9.329z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      fill="#21205e"
      opacity=".15"
      d="M28.917 33.344l3.458-3.458 1.414 1.414-3.458 3.458z"
    ></path>
  </svg>
);

export default Food;
